<template>
  <div class="main">
    <my_menu active_name="1-0" :open_active="['1']"></my_menu>

    <div class="content">
      <div class="options_div">
        <Button
          type="primary"
          size="small"
          style="font-size: 13px"
          @click="click_add_news"
          >+添加新文章</Button
        >
      </div>
      <div class="table_box">
        <Spin fix size="large" v-if="table_loading"></Spin>
        <Table
          size="small"
          :height="windowHeight - 120"
          border
          :columns="columns"
          :data="table_data"
        >
          <template #img="{ row }">
            <div>
              <img @click="click_img(row)" :src="row.img" alt="" class="img_fm" />
            </div>
          </template>
          <template #is_hide_status="{ row }">
            <div>
              <Switch
                size="small"
                v-model="row.is_hide_status"
                @on-change="del_change(row)"
              />
            </div>
          </template>
        </Table>
        <div class="content_page">
          <Page :page-size="20" :total="total_count" @on-change="page_change" />
        </div>
      </div>
    </div>

    <Modal width="420" v-model="add_show" title="添加新文章" :footer-hide="true">
      <div class="add_div">
        <span>文章封面：</span>
        <img
          v-if="add_item.img_url"
          :src="add_item.img_url"
          alt=""
          style="width: 80px; height: 50px; margin-right: 10px"
        />
        <Upload
          :show-upload-list="false"
          :action="img_upload_url"
          :on-success="img_success"
        >
          <Button icon="ios-cloud-upload-outline">上传封面图</Button>
        </Upload>
      </div>
      <div class="add_div">
        <span>文章标题：</span>
        <Input
          v-model="add_item.title"
          placeholder="请输入文章标题..."
          style="width: 300px"
        />
      </div>
      <div class="add_div">
        <span>文章链接：</span>
        <Input
          v-model="add_item.url"
          placeholder="请输入文章链接..."
          style="width: 300px"
        />
      </div>
      <div class="add_div">
        <span>发布日期：</span>
        <DatePicker
          type="date"
          v-model="add_item.date"
          placeholder="请输入发布日期..."
          style="width: 200px"
        />
      </div>
      <div class="add_submit">
        <Button type="primary" @click="add_news">确认添加</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import my_menu from "@/component/admin/menu/menu.vue";
import { http } from "@/utils/http.js";

export default {
  components: {
    my_menu,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度

      //系统列表
      table_data: [],
      columns: [],
      table_loading: false,
      page: 1,
      total_count: 0,
      add_show: false,
      img_upload_url: "",

      add_item: {
        img_url: "",
        img_object: "",
        title: "",
        url: "",
        date: new Date(),
      },
    };
  },

  mounted() {
    this.window_change();
    this.get_news_list();

    this.img_upload_url =
      process.env.VUE_APP_HOST +
      "/ows_manage/news/upload_news_img?token=" +
      this.$cookies.get("dx_token");
  },

  methods: {
    del_change(row) {
      var that = this;
      var obj = {
        news_id: row.news_id,
      };
      http("post", process.env.VUE_APP_HOST + "/ows_manage/news/del_news", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_news_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    add_news() {
      if (this.add_item.img_object == "") {
        this.$Message.error("请上传封面图");
        return;
      }

      if (this.add_item.title == "") {
        this.$Message.error("请输入标题");
        return;
      }
      if (this.add_item.url == "") {
        this.$Message.error("请输入链接");
        return;
      }

      var that = this;
      var obj = {
        title: this.add_item.title,
        url: this.add_item.url,
        img_object: this.add_item.img_object,
        date: this.add_item.date.getTime() / 1000,
      };
      http("post", process.env.VUE_APP_HOST + "/ows_manage/news/add_news", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.add_show = false;
            that.get_news_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    img_success(e) {
      console.log(e);
      if (e.code == 0) {
        this.add_item.img_url = e.data.url;
        this.add_item.img_object = e.data.img_object_name;
        this.$Message.success(e.msg);
      } else {
        this.$Message.error(e.msg);
      }
    },

    click_add_news() {
      this.add_show = true;
    },

    page_change(e) {
      this.page = e;
      this.get_news_list();
    },

    click_img(row) {
      this.$ImagePreview.show({
        previewList: [row.img],
      });
    },

    get_news_list() {
      var that = this;
      var obj = {
        page: this.page,
      };
      this.table_loading = true;
      http("post", process.env.VUE_APP_HOST + "/ows_manage/news/new_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.table_data = res.data.resp_list;
            that.columns = res.data.columns;
            that.total_count = res.data.total_count;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.table_loading = false;
        })
        .catch((res) => {
          that.table_loading = false;

          console.log(res, "请求出错");
        });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.add_submit {
  display: flex;
  justify-content: flex-end;
}

.add_div {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.options_div {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.img_fm {
  width: 100px;
  height: 60px;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  padding: 10px;
  width: calc(100% - 220px);
  background-color: #fff;
  position: absolute;
  right: 10px;
  top: 10px;
  height: calc(100vh - 20px);
  border-radius: 5px;
}

.main {
  background: #ececec;
  min-height: 100vh;
}
</style>
